<template>
  <div
    class="flex items-center gap-4 rounded-2xl bg-yellow-100 p-4 text-gray-900"
    role="status"
  >
    <slot name="icon">
      <IconInfoCircle
        class="size-8 shrink-0 text-orange-250"
        aria-hidden="true"
      />
    </slot>
    <div class="flex min-w-0 flex-1 flex-col gap-px">
      <div class="text-sm font-semibold leading-6">
        <slot name="title">{{ title }}</slot>
      </div>
      <div
        v-if="description || $slots.description"
        class="text-xs font-normal leading-5"
      >
        <slot name="description">{{ description }}</slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconInfoCircle from '~/assets/svg/ui/info-circle.svg?component'

defineProps({
  /** Заголовок, если не задан слот `title` */
  title: {
    type: String,
    default: '',
  },
  /** Подзаголовок; блок скрыт, если пусто и нет слота `description` */
  description: {
    type: String,
    default: '',
  },
})
</script>
